__turbopack_context__.v({
  "group": "segmented-control-module__siG3za__group",
  "seg": "segmented-control-module__siG3za__seg",
});
